// extracted by mini-css-extract-plugin
export var columnList = "_h8-0";